// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagina-historico-contenedores.contenedorprincipal {
  width: 95%;
  margin: 0 auto;
  padding-bottom: 5px;
  display: flex;
  flex-direction: column;
}

.pagina-historico-contenedores .titulo {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 2px;
}

.pagina-historico-contenedores .botonessuperiores {
  display: flex;
  justify-content: center;
  gap: 5px;
  margin-bottom: 15px;
}

/* [EXPERT] Layout automático para permitir que respiren las columnas */
.pagina-historico-contenedores .p-datatable .p-datatable-wrapper table {
  table-layout: auto !important;
  min-width: 100%;
}

.pagina-historico-contenedores .p-datatable .p-datatable-wrapper {
  min-height: 400px;
}

.pagina-historico-contenedores .p-datatable .p-datatable-thead > tr > th {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.35rem !important;
}

.pagina-historico-contenedores .p-datatable .p-datatable-tbody > tr > td {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.3rem !important;
  height: 38px !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/HistoricoContenedores.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;AACzB","sourcesContent":[".pagina-historico-contenedores.contenedorprincipal {\n  width: 95%;\n  margin: 0 auto;\n  padding-bottom: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.pagina-historico-contenedores .titulo {\n  text-align: center;\n  margin-top: 0px;\n  margin-bottom: 2px;\n}\n\n.pagina-historico-contenedores .botonessuperiores {\n  display: flex;\n  justify-content: center;\n  gap: 5px;\n  margin-bottom: 15px;\n}\n\n/* [EXPERT] Layout automático para permitir que respiren las columnas */\n.pagina-historico-contenedores .p-datatable .p-datatable-wrapper table {\n  table-layout: auto !important;\n  min-width: 100%;\n}\n\n.pagina-historico-contenedores .p-datatable .p-datatable-wrapper {\n  min-height: 400px;\n}\n\n.pagina-historico-contenedores .p-datatable .p-datatable-thead > tr > th {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.35rem !important;\n}\n\n.pagina-historico-contenedores .p-datatable .p-datatable-tbody > tr > td {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.3rem !important;\n  height: 38px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
